/** Scroll distance (px) before the header material reaches full strength (iOS scroll-edge). */
export const HEADER_SCROLL_BACKDROP_RANGE_PX = 80;

const HEADER_MATERIAL_MIX_MIN_PERCENT = 18;
const HEADER_MATERIAL_MIX_MAX_PERCENT = 54;

/** iOS-style material tint: clear at scroll top, stronger after scroll (scroll edge effect). */
export function resolveHeaderScrollMaterialMixPercent(scrollY: number): number {
  const progress = Math.min(1, Math.max(0, scrollY / HEADER_SCROLL_BACKDROP_RANGE_PX));
  return (
    HEADER_MATERIAL_MIX_MIN_PERCENT +
    progress * (HEADER_MATERIAL_MIX_MAX_PERCENT - HEADER_MATERIAL_MIX_MIN_PERCENT)
  );
}
